export default __webpack_public_path__ + "static/media/minus.3eb47532.png";